import { render, staticRenderFns } from "./ClusterReport.vue?vue&type=template&id=5240d885"
import script from "./ClusterReport.vue?vue&type=script&lang=js"
export * from "./ClusterReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports